import { Component, inject, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { NavigationHistoryService } from '../navigation-history/navigation-history.service';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.css']
})
export class BackButtonComponent {
  private location = inject(Location);
  private router = inject(Router);
  private navHistory: NavigationHistoryService = inject(NavigationHistoryService);

  // Optional: Provide a specific URL to navigate to
  @Input() fallbackUrl?: string;
  
  // Optional: Provide the entry URL captured from navigation state (deprecated - use service instead)
  @Input() entryUrl?: string | null;

  goBack(): void {
    // Priority 1: Use entryUrl if provided (backward compatibility)
    if (this.entryUrl && this.entryUrl !== '/') {
      this.router.navigateByUrl(this.entryUrl);
    }
    // Priority 2: Use navigation history service
    else if (this.navHistory.getPreviousUrl()) {
      const previousUrl = this.navHistory.getPreviousUrl()!;
      this.router.navigateByUrl(previousUrl);
    }
    // Priority 3: Use fallbackUrl if provided
    else if (this.fallbackUrl) {
      this.router.navigateByUrl(this.fallbackUrl);
    }
    // Priority 4: Use browser history
    else {
      this.location.back();
    }
  }
}
